import request from '../utils'

const activityApi = {
    activityList: async (modelingId) => {
        const req = request.get(`/api/modeling/${modelingId}/activity`)
        const res = await req;
        return res.body;
    }, 
    activityDetail: async (modelingId, activity) => {
        const req = request.get(`/api/modeling/${modelingId}/activity/${activity}`)
        const res = await req;
        return res.body;
    },
    activityUpdate: async (modelingId, activity) => {
        const req = request.put(`/api/modeling/${modelingId}/activity/${activity.id}`).send(activity);
        const res = await req;
        return res.body;
    },
    activityCreate: async (modelingId, activity) => {
        const req = request.post(`/api/modeling/${modelingId}/activity`).send(activity);
        const res = await req;
        return res.body;
    },
    activityDelete: async (modelingId, activityId) => {
        const req = request.delete(`/api/modeling/${modelingId}/activity/${activityId}`);
        await req;
    }
};

export default activityApi